import React from "react";
import { UserProvider } from "../../context/UserContext";
import UserDashboard from "./UserDashboard";

const UserPanel = () => {
  return (
    <UserProvider>
      <UserDashboard />
    </UserProvider>
  );
};

export default UserPanel;
